import {any, compose, identity, path, pathOr, values} from 'ramda'
import {createSelector} from 'reselect'
import {REDUCER_KEY as ROOT_REDUCER_KEY} from '../constants'

export const selectMatchPending = path([ROOT_REDUCER_KEY, 'submit', 'pending'])
export const selectMatchError = path([ROOT_REDUCER_KEY, 'submit', 'error'])
export const selectMatchCompleted = path([ROOT_REDUCER_KEY, 'submit', 'completed'])

export const selectAggregateMatchPending = createSelector(
  selectMatchPending,
  compose(any(identity), values)
)

export const selectAggregateMatchCompleted = createSelector(
  selectMatchCompleted,
  compose(any(identity), values)
)

export const selectBuyerReduction = pathOr(
  [],
  [ROOT_REDUCER_KEY, 'feature', 'selectedBuyerReduction']
)
